import { QueryClient } from 'react-query';

export const dashboardQueryClient = new QueryClient( {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  }
} );
